module.exports = __webpack_public_path__ + "static/media/AppleHalf.0e0a0a27.png";